var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 295,
    height: 140,
    viewBox: "0 0 295 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-40 -1051)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 295,
    height: 140,
    transform: "translate(40 1051)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(97.017 1051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.951,109.26H119.973v-7.385h12.978Zm-12.431-.553H132.4v-6.278H120.52Z",
    transform: "translate(16.575 14.075)",
    fill: "#0d71e8",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.353,108.937H131.375v-7.385h12.978Zm-12.43-.554H143.8v-6.277H131.924Z",
    transform: "translate(18.15 14.03)",
    fill: "#0d71e8",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.757,108.937H142.779v-7.385h12.978Zm-12.43-.554H155.21v-6.277H143.328Z",
    transform: "translate(19.726 14.03)",
    fill: "#0d71e8",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.757,102.448H142.779V95.062h12.978Zm-12.43-.554H155.21V95.616H143.328Z",
    transform: "translate(19.726 13.133)",
    fill: "#0d71e8",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.353,102.448H131.375V95.062h12.978Zm-12.43-.554H143.8V95.616H131.924Z",
    transform: "translate(18.15 13.133)",
    fill: "#0d71e8",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.869,108.937H2.891v-7.385H15.869Zm-12.43-.554H15.321v-6.277H3.439Z",
    transform: "translate(0.399 14.03)",
    fill: "#0d71e8",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.271,108.937H14.293v-7.385H27.271Zm-12.43-.554H26.723v-6.277H14.841Z",
    transform: "translate(1.975 14.03)",
    fill: "#0d71e8",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.676,108.937H25.7v-7.385H38.676Zm-12.43-.554H38.127v-6.277H26.246Z",
    transform: "translate(3.55 14.03)",
    fill: "#0d71e8",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.078,109.26H37.1v-7.385H50.078Zm-12.43-.553H49.53v-6.278H37.648Z",
    transform: "translate(5.126 14.075)",
    fill: "#0d71e8",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.676,102.448H25.7V95.062H38.676Zm-12.43-.554H38.127V95.616H26.246Z",
    transform: "translate(3.55 13.133)",
    fill: "#0d71e8",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.271,102.448H14.293V95.062H27.271Zm-12.43-.554H26.723V95.616H14.841Z",
    transform: "translate(1.975 13.133)",
    fill: "#0d71e8",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.1,91.175s-2.4-8.24.45-14.305a13.132,13.132,0,0,0,1.043-8.165,22.024,22.024,0,0,0-1.145-3.833",
    transform: "translate(19.639 8.963)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.289,61.722c0,1.01-1.81,3.938-1.81,3.938s-1.81-2.928-1.81-3.938a1.84,1.84,0,0,1,.53-1.293,1.8,1.8,0,0,1,2.561,0,1.84,1.84,0,0,1,.53,1.293Z",
    transform: "translate(19.573 8.275)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.923,66.763c-.549.847-3.64,2.312-3.64,2.312s.057-3.453.6-4.3a1.8,1.8,0,0,1,3.01-.045,1.844,1.844,0,0,1,.03,2.032Z",
    transform: "translate(19.934 8.834)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.885,75.24c-.892.454-4.3.14-4.3.14s1.773-2.954,2.667-3.406a1.794,1.794,0,0,1,1.382-.1,1.816,1.816,0,0,1,1.051.914,1.846,1.846,0,0,1,.1,1.4,1.825,1.825,0,0,1-.9,1.061Z",
    transform: "translate(19.838 9.917)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.372,81.555c-.8.6-4.2.871-4.2.871s1.254-3.211,2.058-3.813a1.8,1.8,0,0,1,2.532.382,1.848,1.848,0,0,1,.335,1.358,1.853,1.853,0,0,1-.238.671,1.831,1.831,0,0,1-.476.528Z",
    transform: "translate(19.641 10.811)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.01,69.007c.717.7,4.059,1.433,4.059,1.433s-.819-3.353-1.535-4.062a1.8,1.8,0,0,0-2.561.038A1.842,1.842,0,0,0,141.01,69Z",
    transform: "translate(19.405 9.099)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.4,76.475c.891.454,4.3.14,4.3.14s-1.773-2.954-2.667-3.407a1.8,1.8,0,0,0-1.383-.1,1.818,1.818,0,0,0-1.049.914,1.846,1.846,0,0,0-.1,1.4,1.823,1.823,0,0,0,.9,1.061Z",
    transform: "translate(19.121 10.087)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.729,83.9c.8.6,4.2.871,4.2.871s-1.246-3.2-2.053-3.811a1.795,1.795,0,0,0-2.009-.1,1.813,1.813,0,0,0-.522.48,1.847,1.847,0,0,0-.1,2.029,1.83,1.83,0,0,0,.476.528Z",
    transform: "translate(19.065 11.136)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.289,61.722c0,1.01-1.81,3.938-1.81,3.938s-1.81-2.928-1.81-3.938a1.84,1.84,0,0,1,.53-1.293,1.8,1.8,0,0,1,2.561,0,1.84,1.84,0,0,1,.53,1.293Z",
    transform: "translate(19.573 8.275)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.923,66.763c-.549.847-3.64,2.312-3.64,2.312s.057-3.453.6-4.3a1.8,1.8,0,0,1,3.01-.045,1.844,1.844,0,0,1,.03,2.032Z",
    transform: "translate(19.934 8.834)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.885,75.24c-.892.454-4.3.14-4.3.14s1.773-2.954,2.667-3.406a1.794,1.794,0,0,1,1.382-.1,1.816,1.816,0,0,1,1.051.914,1.846,1.846,0,0,1,.1,1.4,1.825,1.825,0,0,1-.9,1.061Z",
    transform: "translate(19.838 9.917)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.372,81.555c-.8.6-4.2.871-4.2.871s1.254-3.211,2.058-3.813a1.8,1.8,0,0,1,2.532.382,1.848,1.848,0,0,1,.335,1.358,1.853,1.853,0,0,1-.238.671,1.831,1.831,0,0,1-.476.528Z",
    transform: "translate(19.641 10.811)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.01,69.007c.717.7,4.059,1.433,4.059,1.433s-.819-3.353-1.535-4.062a1.8,1.8,0,0,0-2.561.038A1.842,1.842,0,0,0,141.01,69Z",
    transform: "translate(19.405 9.099)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.4,76.475c.891.454,4.3.14,4.3.14s-1.773-2.954-2.667-3.407a1.8,1.8,0,0,0-1.383-.1,1.818,1.818,0,0,0-1.049.914,1.846,1.846,0,0,0-.1,1.4,1.823,1.823,0,0,0,.9,1.061Z",
    transform: "translate(19.121 10.087)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.729,83.9c.8.6,4.2.871,4.2.871s-1.246-3.2-2.053-3.811a1.795,1.795,0,0,0-2.009-.1,1.813,1.813,0,0,0-.522.48,1.847,1.847,0,0,0-.1,2.029,1.83,1.83,0,0,0,.476.528Z",
    transform: "translate(19.065 11.136)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.228,91.279s-2.438-8.362.457-14.51a13.329,13.329,0,0,0,1.058-8.286,22.382,22.382,0,0,0-1.163-3.9",
    transform: "translate(3.629 8.922)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.449,61.4c0,1.025-1.837,4-1.837,4s-1.839-2.982-1.839-4a1.865,1.865,0,0,1,.538-1.312,1.824,1.824,0,0,1,2.6,0,1.865,1.865,0,0,1,.538,1.312Z",
    transform: "translate(3.561 8.227)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.12,66.507c-.548.86-3.693,2.347-3.693,2.347s.057-3.508.609-4.363a1.838,1.838,0,0,1,1.159-.834,1.822,1.822,0,0,1,1.4.253,1.857,1.857,0,0,1,.8,1.188,1.872,1.872,0,0,1-.279,1.41Z",
    transform: "translate(3.927 8.788)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.084,75.105c-.914.462-4.36.142-4.36.142s1.8-2.995,2.705-3.456a1.82,1.82,0,0,1,1.4-.105,1.843,1.843,0,0,1,1.065.927,1.873,1.873,0,0,1,.1,1.416A1.851,1.851,0,0,1,32.084,75.105Z",
    transform: "translate(3.83 9.891)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.553,81.515c-.815.609-4.274.884-4.274.884s1.28-3.259,2.089-3.877a1.83,1.83,0,0,1,2.574.384,1.868,1.868,0,0,1-.38,2.6Z",
    transform: "translate(3.631 10.798)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.107,68.78c.731.715,4.118,1.453,4.118,1.453s-.83-3.4-1.557-4.115a1.838,1.838,0,0,0-.6-.4,1.821,1.821,0,0,0-1.417.011,1.847,1.847,0,0,0-.987,1.027,1.867,1.867,0,0,0,.448,2.028Z",
    transform: "translate(3.389 9.06)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.469,76.364c.914.462,4.36.142,4.36.142s-1.8-2.995-2.705-3.456a1.821,1.821,0,0,0-1.4-.105,1.843,1.843,0,0,0-1.065.927,1.873,1.873,0,0,0-.1,1.416A1.851,1.851,0,0,0,23.469,76.364Z",
    transform: "translate(3.103 10.065)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.791,83.9c.815.609,4.274.884,4.274.884s-1.28-3.259-2.089-3.877a1.828,1.828,0,0,0-2.574.384,1.87,1.87,0,0,0,.38,2.6Z",
    transform: "translate(3.045 11.127)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.449,61.4c0,1.025-1.837,4-1.837,4s-1.839-2.982-1.839-4a1.865,1.865,0,0,1,.538-1.312,1.824,1.824,0,0,1,2.6,0,1.865,1.865,0,0,1,.538,1.312Z",
    transform: "translate(3.561 8.227)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.12,66.507c-.548.86-3.693,2.347-3.693,2.347s.057-3.508.609-4.363a1.838,1.838,0,0,1,1.159-.834,1.822,1.822,0,0,1,1.4.253,1.857,1.857,0,0,1,.8,1.188,1.872,1.872,0,0,1-.279,1.41Z",
    transform: "translate(3.927 8.788)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.084,75.105c-.914.462-4.36.142-4.36.142s1.8-2.995,2.705-3.456a1.82,1.82,0,0,1,1.4-.105,1.843,1.843,0,0,1,1.065.927,1.873,1.873,0,0,1,.1,1.416A1.851,1.851,0,0,1,32.084,75.105Z",
    transform: "translate(3.83 9.891)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.553,81.515c-.815.609-4.274.884-4.274.884s1.28-3.259,2.089-3.877a1.83,1.83,0,0,1,2.574.384,1.868,1.868,0,0,1-.38,2.6Z",
    transform: "translate(3.631 10.798)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.107,68.78c.731.715,4.118,1.453,4.118,1.453s-.83-3.4-1.557-4.115a1.838,1.838,0,0,0-.6-.4,1.821,1.821,0,0,0-1.417.011,1.847,1.847,0,0,0-.987,1.027,1.867,1.867,0,0,0,.448,2.028Z",
    transform: "translate(3.389 9.06)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.469,76.364c.914.462,4.36.142,4.36.142s-1.8-2.995-2.705-3.456a1.821,1.821,0,0,0-1.4-.105,1.843,1.843,0,0,0-1.065.927,1.873,1.873,0,0,0-.1,1.416A1.851,1.851,0,0,0,23.469,76.364Z",
    transform: "translate(3.103 10.065)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.791,83.9c.815.609,4.274.884,4.274.884s-1.28-3.259-2.089-3.877a1.828,1.828,0,0,0-2.574.384,1.87,1.87,0,0,0,.38,2.6Z",
    transform: "translate(3.045 11.127)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.975,90.325s-1.857-6.364.349-11.063a10.157,10.157,0,0,0,.806-6.314,17.071,17.071,0,0,0-.885-2.963",
    transform: "translate(1.968 9.669)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.672,67.55a11.264,11.264,0,0,1-1.4,3.046,11.264,11.264,0,0,1-1.4-3.046,1.421,1.421,0,0,1,.41-1,1.39,1.39,0,0,1,1.98,0A1.421,1.421,0,0,1,16.672,67.55Z",
    transform: "translate(1.916 9.137)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.706,71.445a11.1,11.1,0,0,1-2.815,1.789,11.294,11.294,0,0,1,.464-3.323,1.406,1.406,0,0,1,.381-.4,1.389,1.389,0,0,1,1.556-.022,1.407,1.407,0,0,1,.392.385,1.427,1.427,0,0,1,.022,1.572Z",
    transform: "translate(2.195 9.569)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.679,78a11.016,11.016,0,0,1-3.323.109,11.2,11.2,0,0,1,2.062-2.635,1.388,1.388,0,0,1,1.069-.08,1.4,1.4,0,0,1,.812.706,1.427,1.427,0,0,1,.08,1.08A1.411,1.411,0,0,1,18.679,78Z",
    transform: "translate(2.121 10.406)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.507,82.886a10.971,10.971,0,0,1-3.257.674,11.366,11.366,0,0,1,1.592-2.954,1.391,1.391,0,0,1,1.959.3,1.424,1.424,0,0,1-.293,1.978Z",
    transform: "translate(1.969 11.098)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.359,73.18c.548.545,3.139,1.108,3.139,1.108a11.372,11.372,0,0,0-1.188-3.139,1.392,1.392,0,0,0-1.981.03,1.424,1.424,0,0,0,.03,2Z",
    transform: "translate(1.787 9.774)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.113,78.957a11.02,11.02,0,0,0,3.323.109,11.2,11.2,0,0,0-2.062-2.635,1.388,1.388,0,0,0-1.069-.081,1.4,1.4,0,0,0-.812.706,1.427,1.427,0,0,0-.08,1.08A1.411,1.411,0,0,0,12.113,78.957Z",
    transform: "translate(1.567 10.539)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6,84.7a10.971,10.971,0,0,0,3.257.674,11.368,11.368,0,0,0-1.592-2.954,1.393,1.393,0,0,0-1.959.3A1.422,1.422,0,0,0,11.6,84.7Z",
    transform: "translate(1.523 11.349)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.672,67.55a11.264,11.264,0,0,1-1.4,3.046,11.264,11.264,0,0,1-1.4-3.046,1.421,1.421,0,0,1,.41-1,1.39,1.39,0,0,1,1.98,0A1.421,1.421,0,0,1,16.672,67.55Z",
    transform: "translate(1.916 9.137)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.706,71.445a11.1,11.1,0,0,1-2.815,1.789,11.294,11.294,0,0,1,.464-3.323,1.406,1.406,0,0,1,.381-.4,1.389,1.389,0,0,1,1.556-.022,1.407,1.407,0,0,1,.392.385,1.427,1.427,0,0,1,.022,1.572Z",
    transform: "translate(2.195 9.569)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.679,78a11.016,11.016,0,0,1-3.323.109,11.2,11.2,0,0,1,2.062-2.635,1.388,1.388,0,0,1,1.069-.08,1.4,1.4,0,0,1,.812.706,1.427,1.427,0,0,1,.08,1.08A1.411,1.411,0,0,1,18.679,78Z",
    transform: "translate(2.121 10.406)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.507,82.886a10.971,10.971,0,0,1-3.257.674,11.366,11.366,0,0,1,1.592-2.954,1.391,1.391,0,0,1,1.959.3,1.424,1.424,0,0,1-.293,1.978Z",
    transform: "translate(1.969 11.098)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.359,73.18c.548.545,3.139,1.108,3.139,1.108a11.372,11.372,0,0,0-1.188-3.139,1.392,1.392,0,0,0-1.981.03,1.424,1.424,0,0,0,.03,2Z",
    transform: "translate(1.787 9.774)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.113,78.957a11.02,11.02,0,0,0,3.323.109,11.2,11.2,0,0,0-2.062-2.635,1.388,1.388,0,0,0-1.069-.081,1.4,1.4,0,0,0-.812.706,1.427,1.427,0,0,0-.08,1.08A1.411,1.411,0,0,0,12.113,78.957Z",
    transform: "translate(1.567 10.539)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6,84.7a10.971,10.971,0,0,0,3.257.674,11.368,11.368,0,0,0-1.592-2.954,1.393,1.393,0,0,0-1.959.3A1.422,1.422,0,0,0,11.6,84.7Z",
    transform: "translate(1.523 11.349)",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 14.771)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.967,12.978H0v93.24H180.967Z",
    transform: "translate(0 -12.978)",
    fill: "#0d71e8",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,12.978V106.4H180.967V12.978ZM8.043,21.1H86.462V55.628H8.043Zm0,42.65H86.462V98.279H8.043Zm164.88,34.527H94.5V63.752h78.419Zm0-42.65H94.5V21.1h78.419Z",
    transform: "translate(0 -12.978)",
    opacity: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.342 30.606)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.505,98.694S44.668,92.845,42.5,101.077l6.074,15.6.651,9.97H62.458v-8.454s-1.952-8.449,3.038-13.646Z",
    transform: "translate(-34.471 -17.249)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.798 34.786)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.335,57.7a2.159,2.159,0,0,0-2.031.022,5.178,5.178,0,0,0-.7,1.008c-.821,1.088-2.475.884-3.782,1.274-1.921.572-3.108,2.494-3.788,4.378-3.009,8.308.346,17.812-2.274,26.249-.771,2.483-2.033,5.24-.786,7.524a9.974,9.974,0,0,1,1.3,2.24c.281,1.143-.261,2.642.687,3.338a2.792,2.792,0,0,0,1.025.369c2.135.569,3.753,2.247,5.38,3.739s3.583,2.935,5.789,2.837a9.3,9.3,0,0,0,2.1-.421l10.949-3.08a4.925,4.925,0,0,0,2.925-1.626,4.672,4.672,0,0,0,.611-1.979,52.67,52.67,0,0,0,.536-7.926,6.931,6.931,0,0,0-.366-2.585,16.62,16.62,0,0,0-1.629-2.55A13.882,13.882,0,0,1,76.72,84.92a29.966,29.966,0,0,1-.249-9.27c.239-1.311.653-2.585.927-3.887a18.618,18.618,0,0,0,.208-6.449,9.222,9.222,0,0,0-2.011-4.93,5.088,5.088,0,0,0-3.034-1.662c-1.481-.185-2.217.676-3.537,1C67.072,60.213,64.213,58.326,62.335,57.7Z",
    transform: "translate(-48.447 -57.454)",
    fill: "#fff",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M62.335,57.312a2.159,2.159,0,0,0-2.031.022,5.178,5.178,0,0,0-.7,1.008c-.821,1.088-2.475.884-3.782,1.274-1.921.572-3.108,2.494-3.788,4.378-3.009,8.309.346,17.812-2.274,26.249-.771,2.483-2.033,5.24-.786,7.524a9.974,9.974,0,0,1,1.3,2.24c.281,1.143-.261,2.642.687,3.338a2.793,2.793,0,0,0,1.025.369c2.135.569,3.753,2.247,5.38,3.739s3.579,2.952,5.789,2.849a9.3,9.3,0,0,0,2.1-.421L76.2,106.8a4.925,4.925,0,0,0,2.925-1.626,4.673,4.673,0,0,0,.611-1.979,52.669,52.669,0,0,0,.536-7.926,6.931,6.931,0,0,0-.366-2.585,16.619,16.619,0,0,0-1.629-2.55,13.883,13.883,0,0,1-1.557-5.591,29.966,29.966,0,0,1-.249-9.271c.239-1.311.653-2.585.927-3.887a18.617,18.617,0,0,0,.208-6.449,9.221,9.221,0,0,0-2.011-4.93,5.087,5.087,0,0,0-3.034-1.662c-1.481-.185-2.217.676-3.537,1C67.072,59.823,64.213,57.947,62.335,57.312Z",
    transform: "translate(-33.649 -22.722)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.28,42.882s.217,8.231-2.385,8.015,7.368,13.646,7.368,13.646l8.46-4.549s-4.987-8.013-1.514-13S58.28,42.882,58.28,42.882Z",
    transform: "translate(-32.68 -24.689)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.267 31.322)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.356,111.248s-1.735,11.914-6.074,8.665-3.689-8.665-3.689-8.665,8.462-22.961,8.028-26.428S59.062,54.411,59.062,54.411l5.509,44.273S48.091,104.749,46.356,111.248Z",
    transform: "translate(-36.559 -54.411)",
    fill: "#fff",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.975,111.248s-1.735,11.914-6.074,8.665-3.689-8.665-3.689-8.665,8.462-22.961,8.027-26.428S58.68,54.411,58.68,54.411l5.509,44.273S47.71,104.749,45.975,111.248Z",
    transform: "translate(-35.344 -23.089)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.479,47.443s-8.462,5.844-11.719,5.631l-2.528.694A13.85,13.85,0,0,0,40.7,57.724a14.066,14.066,0,0,0-3.482,6.841l-.04.207c-1.3,6.933-1.733,26-1.733,26s.217,4.985,2.385,6.278l13.892,9.531S51.29,96.179,56.5,95.1s-1.3-.434-1.3-.434L45.649,89.03s.218-8.449,2.821-11.263,11.715-17.54,11.715-17.54l-2.6-9.1Z",
    transform: "translate(-35.445 -24.051)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.1 29.024)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.666,52.391s5.328,1.409,9.059,2.1a3.736,3.736,0,0,1,1.6.706,3.784,3.784,0,0,1,1.111,1.362c1.126,2.347,2.842,6.592,2.546,10.131l3.254,12.78L93.561,90.73l-8.458,3.9L75.561,84.017l7.809,20.145-14.536.65s-4.34-32.5-3.254-37.907Z",
    transform: "translate(-65.406 -52.391)",
    fill: "#fff",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.047,52.391s5.328,1.409,9.059,2.1a3.736,3.736,0,0,1,1.6.706,3.784,3.784,0,0,1,1.111,1.362c1.126,2.347,2.842,6.592,2.546,10.131l3.254,12.78L93.942,90.73l-8.46,3.9L75.937,84.015l7.816,20.147-14.536.65s-4.34-32.5-3.254-37.907Z",
    transform: "translate(-31.253 -23.368)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.246,46.837,61.237,61.5l-4.881,2.491L53.682,50.782Z",
    transform: "translate(-32.926 -24.135)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.895,61.815l2.278-9.424,2.93,5.524-1.519,4.549Z",
    transform: "translate(-31.377 -23.368)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.137,63.145s0,14.73,1.952,15.812Z",
    transform: "translate(-30.376 -21.882)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.969,66.38s-4.5,14.507-3.228,16.026Z",
    transform: "translate(-34.192 -21.435)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.787,83.886s8.679,5.666,9.871,5.757Z",
    transform: "translate(-33.878 -19.016)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.733 19.001)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.139,43.643s.033,1.268-.084,2.8a10.06,10.06,0,0,0,3.692,4.44,9.913,9.913,0,0,0,5.5,1.653,10.054,10.054,0,0,0,1.6-.129,7.487,7.487,0,0,1,1.221-4.636C73.541,42.777,58.139,43.643,58.139,43.643Z",
    transform: "translate(-58.055 -43.585)",
    fill: "#fff",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.155,53.1a9.965,9.965,0,1,0-9.979-9.965A9.972,9.972,0,0,0,67.155,53.1Z",
    transform: "translate(-32.443 -26.023)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.189 0.217)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.037,39.786c1.208.163,2.742-.24,2.981-1.436.294-1.51-1.729-2.493-2.042-4-.117-.565.022-1.156-.046-1.73A4.229,4.229,0,0,0,72.907,29.9a15.579,15.579,0,0,0-10.35-2.755,2.3,2.3,0,0,0-1.28.406,4.9,4.9,0,0,0-.824,1.292c-.936,1.51-3.038,1.688-4.546,2.629a6.523,6.523,0,0,0-2.716,5.338,19.4,19.4,0,0,0,1.1,6.106A13.96,13.96,0,0,0,56.4,47.742a4.765,4.765,0,0,0,4.632,1.94c-.788-.567-.216-1.883.638-2.345s1.914-.541,2.643-1.178A4.916,4.916,0,0,0,65.5,43.53a6.869,6.869,0,0,1,1.609-3.285C68.832,38.536,71.931,39.5,74.037,39.786Z",
    transform: "translate(-53.184 -27.081)",
    fill: "#fff",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.842,39.6c1.208.163,2.742-.24,2.981-1.436.294-1.51-1.729-2.493-2.042-4-.117-.565.022-1.156-.046-1.73a4.228,4.228,0,0,0-2.024-2.718,15.58,15.58,0,0,0-10.343-2.757,2.3,2.3,0,0,0-1.28.406,4.9,4.9,0,0,0-.824,1.292c-.936,1.51-3.038,1.688-4.546,2.629A6.524,6.524,0,0,0,53,36.62a19.4,19.4,0,0,0,1.1,6.106,13.959,13.959,0,0,0,2.117,4.824,4.765,4.765,0,0,0,4.632,1.941c-.788-.567-.216-1.883.638-2.345s1.914-.541,2.643-1.178a4.917,4.917,0,0,0,1.186-2.629,6.87,6.87,0,0,1,1.609-3.285C68.643,38.346,71.741,39.312,73.842,39.6Z",
    transform: "translate(-33.021 -26.891)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.83 17.654)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.809,43.2a13.19,13.19,0,0,1-1.084,3.94,31.665,31.665,0,0,0-2.071,4.572,72.7,72.7,0,0,1,6.032,5.2,4.705,4.705,0,0,0,4.976,1.217,3.191,3.191,0,0,0,2.232-2.518,8.263,8.263,0,0,0-.508-4.832,3.624,3.624,0,0,1-.015-2.954,1.169,1.169,0,0,1,.521-.657s-3.9-.866-4.122.216-3.254,2.166-3.9.216l-.183-4.3a.95.95,0,0,0-.291-.641.947.947,0,0,0-1.264-.035A.947.947,0,0,0,64.809,43.2Z",
    transform: "translate(-61.654 -42.402)",
    fill: "#fff",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.809,43.394a13.19,13.19,0,0,1-1.084,3.94,31.666,31.666,0,0,0-2.071,4.572,72.7,72.7,0,0,1,6.032,5.2,4.706,4.706,0,0,0,4.976,1.217A3.192,3.192,0,0,0,74.894,55.8a8.263,8.263,0,0,0-.508-4.832,3.624,3.624,0,0,1-.015-2.954,1.169,1.169,0,0,1,.521-.657s-3.9-.866-4.122.216-3.254,2.166-3.9.216l-.183-4.3a.95.95,0,0,0-.291-.641.947.947,0,0,0-1.264-.035A.947.947,0,0,0,64.809,43.394Z",
    transform: "translate(-31.824 -24.721)",
    fill: "#fff",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.6,98.562s-15.2-5.679-17.285,2.313l5.831,15.14.62,9.688h12.7V117.5s-1.874-8.2,2.925-13.253Z",
    transform: "translate(5.984 13.347)",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.36,58.753a2.052,2.052,0,0,0-1.949.022,5.058,5.058,0,0,0-.674.978c-.788,1.056-2.376.859-3.63,1.237-1.844.554-2.981,2.422-3.636,4.247-2.888,8.067.331,17.3-2.183,25.491-.731,2.411-1.95,5.089-.755,7.306a9.9,9.9,0,0,1,1.247,2.175c.271,1.108-.251,2.566.66,3.242a2.879,2.879,0,0,0,.983.369c2.049.554,3.6,2.183,5.164,3.632s3.44,2.851,5.557,2.757a8.917,8.917,0,0,0,2.011-.407l10.511-2.991a4.747,4.747,0,0,0,2.81-1.581,4.653,4.653,0,0,0,.587-1.922,51.721,51.721,0,0,0,.514-7.7,6.868,6.868,0,0,0-.347-2.509,17.48,17.48,0,0,0-1.565-2.478,13.59,13.59,0,0,1-1.5-5.43,29.493,29.493,0,0,1-.239-9c.23-1.272.627-2.509.89-3.774a18.288,18.288,0,0,0,.2-6.263,9.029,9.029,0,0,0-1.928-4.788,4.87,4.87,0,0,0-2.914-1.614c-1.422-.185-2.129.657-3.4.969C66.908,61.185,64.163,59.363,62.36,58.753Z",
    transform: "translate(6.774 8.084)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.36,58.383a2.053,2.053,0,0,0-1.949.022,5.05,5.05,0,0,0-.674.979c-.788,1.056-2.376.859-3.63,1.237-1.844.554-2.981,2.422-3.636,4.247-2.888,8.067.331,17.3-2.183,25.491-.731,2.411-1.95,5.088-.755,7.306a9.9,9.9,0,0,1,1.247,2.175c.271,1.108-.251,2.566.66,3.242a2.879,2.879,0,0,0,.983.369c2.049.554,3.6,2.182,5.164,3.632s3.44,2.851,5.557,2.757a8.918,8.918,0,0,0,2.011-.407l10.513-2.99a4.74,4.74,0,0,0,2.81-1.58,4.654,4.654,0,0,0,.587-1.922,51.706,51.706,0,0,0,.514-7.7,6.869,6.869,0,0,0-.347-2.509,17.484,17.484,0,0,0-1.565-2.478,13.588,13.588,0,0,1-1.5-5.43,29.493,29.493,0,0,1-.239-9c.23-1.272.627-2.509.89-3.774a18.289,18.289,0,0,0,.2-6.263A9.03,9.03,0,0,0,75.094,61a4.87,4.87,0,0,0-2.908-1.619c-1.422-.185-2.129.657-3.4.969C66.908,60.817,64.163,58.993,62.36,58.383Z",
    transform: "translate(6.774 8.033)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.468,44.365s.208,7.993-2.29,7.782S63.259,65.4,63.259,65.4l8.122-4.418S66.591,53.2,69.918,48.36,58.468,44.365,58.468,44.365Z",
    transform: "translate(7.704 6.121)",
    fill: "#fda57d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.02,110.756s-1.665,11.568-5.831,8.413-3.541-8.413-3.541-8.413,8.122-22.3,7.7-25.665,13.87-29.532,13.87-29.532l5.288,42.994S48.686,104.445,47.02,110.756Z",
    transform: "translate(5.197 7.676)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.653,110.756s-1.665,11.568-5.831,8.413-3.541-8.413-3.541-8.413,8.122-22.3,7.7-25.665,13.87-29.532,13.87-29.532l5.288,42.994S48.319,104.445,46.653,110.756Z",
    transform: "translate(5.146 7.676)",
    fill: "#4d8af0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.537,48.793s-8.122,5.679-11.246,5.469l-2.427.674a13.391,13.391,0,0,0-6.286,3.858,13.6,13.6,0,0,0-3.327,6.626l-.038.2c-1.25,6.732-1.665,25.243-1.665,25.243s.208,4.837,2.29,6.093l13.328,9.265s-.417-10.1,4.583-11.148-1.25-.421-1.25-.421l-9.164-5.471s.208-8.2,2.707-10.938S60.286,61.206,60.286,61.206l-2.5-8.844Z",
    transform: "translate(5.049 6.741)",
    fill: "#4d8af0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.518,53.6s5.118,1.368,8.7,2.031a3.591,3.591,0,0,1,1.54.689,3.638,3.638,0,0,1,1.063,1.32c1.08,2.28,2.727,6.4,2.444,9.837l3.124,12.411,8.957,10.938L84.22,94.618,75.062,84.312l7.495,19.571L68.6,104.5s-4.166-31.554-3.124-36.812Z",
    transform: "translate(9.023 7.405)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.885,53.6s5.118,1.368,8.7,2.031a3.592,3.592,0,0,1,1.54.689,3.638,3.638,0,0,1,1.063,1.32c1.08,2.28,2.727,6.4,2.444,9.837l3.124,12.411L92.71,90.826l-8.122,3.787L75.425,84.3l7.495,19.571-13.953.628S64.8,72.949,65.843,67.691Z",
    transform: "translate(9.073 7.405)",
    fill: "#4d8af0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.434,48.206l2.872,14.237-4.687,2.419L54.053,52.037Z",
    transform: "translate(7.468 6.66)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.816,62.75,67,53.6l2.811,5.364-1.457,4.418Z",
    transform: "translate(8.955 7.405)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.771,64.042s0,14.3,1.874,15.356Z",
    transform: "translate(9.916 8.848)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.569,67.178s-4.323,14.088-3.108,15.563Z",
    transform: "translate(6.251 9.281)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.434,84.187s8.332,5.5,9.476,5.591Z",
    transform: "translate(6.553 11.631)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.33,45.1s.033,1.231-.08,2.714a9.645,9.645,0,0,0,4.191,4.7A9.5,9.5,0,0,0,68.613,53.6a7.346,7.346,0,0,1,1.172-4.5C73.113,44.263,58.33,45.1,58.33,45.1Z",
    transform: "translate(8.048 6.224)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.987,54.286a9.677,9.677,0,1,0-9.58-9.677A9.629,9.629,0,0,0,66.987,54.286Z",
    transform: "translate(7.931 4.826)",
    fill: "#fda57d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.594,41.357c1.161.157,2.64-.234,2.863-1.394.283-1.468-1.66-2.421-1.96-3.877-.113-.554.022-1.123-.044-1.678a4.1,4.1,0,0,0-1.943-2.638A14.829,14.829,0,0,0,62.575,29.1a2.212,2.212,0,0,0-1.23.393,4.631,4.631,0,0,0-.791,1.259c-.9,1.466-2.925,1.64-4.363,2.553a6.351,6.351,0,0,0-2.609,5.185,18.889,18.889,0,0,0,1.057,5.929A13.614,13.614,0,0,0,56.67,49.1a4.549,4.549,0,0,0,4.446,1.883c-.757-.554-.207-1.83.612-2.277s1.828-.524,2.539-1.145a4.7,4.7,0,0,0,1.139-2.553,6.744,6.744,0,0,1,1.545-3.19C68.6,40.137,71.566,41.082,73.594,41.357Z",
    transform: "translate(7.402 4.011)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.419,41.173c1.161.157,2.64-.234,2.863-1.394.283-1.468-1.66-2.421-1.96-3.877-.113-.554.022-1.123-.044-1.678a4.135,4.135,0,0,0-1.956-2.648A14.829,14.829,0,0,0,62.393,28.9a2.213,2.213,0,0,0-1.23.393,4.639,4.639,0,0,0-.791,1.259c-.9,1.466-2.925,1.64-4.363,2.553A6.351,6.351,0,0,0,53.4,38.291a18.889,18.889,0,0,0,1.057,5.929A13.619,13.619,0,0,0,56.489,48.9a4.549,4.549,0,0,0,4.446,1.883c-.757-.554-.207-1.83.612-2.277s1.828-.524,2.539-1.145a4.7,4.7,0,0,0,1.139-2.553,6.746,6.746,0,0,1,1.545-3.19C68.416,39.959,71.39,40.9,73.419,41.173Z",
    transform: "translate(7.376 3.984)",
    fill: "#bcafaa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.736,44.677A12.9,12.9,0,0,1,63.694,48.5a30.917,30.917,0,0,0-1.989,4.431,68.944,68.944,0,0,1,5.785,5.05,4.48,4.48,0,0,0,4.776,1.182,3.08,3.08,0,0,0,2.142-2.445,8.178,8.178,0,0,0-.486-4.693,3.556,3.556,0,0,1-.007-2.865,1.14,1.14,0,0,1,.5-.639s-3.749-.842-3.957.21-3.124,2.1-3.749.21l-.172-4.175a.916.916,0,0,0-.277-.621.906.906,0,0,0-1.221-.033A.913.913,0,0,0,64.736,44.677Z",
    transform: "translate(8.525 6.064)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.736,44.861a12.9,12.9,0,0,1-1.042,3.826,30.917,30.917,0,0,0-1.989,4.431,68.944,68.944,0,0,1,5.785,5.05,4.48,4.48,0,0,0,4.776,1.182A3.08,3.08,0,0,0,74.409,56.9a8.178,8.178,0,0,0-.486-4.693,3.557,3.557,0,0,1-.013-2.873,1.141,1.141,0,0,1,.5-.639s-3.749-.842-3.957.21-3.119,2.112-3.749.225l-.172-4.175a.916.916,0,0,0-.277-.621.9.9,0,0,0-1.216-.034A.913.913,0,0,0,64.736,44.861Z",
    transform: "translate(8.525 6.091)",
    fill: "#bcafaa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.311,106.345a22.811,22.811,0,0,1-5.148-8.862h.324l-.156-.439h.156L131,95.636a9.86,9.86,0,0,0,2.579-3.471c.282-1.278.561-8.19.732-12.995l.15.037a4.064,4.064,0,0,0,.417-2.149,8.422,8.422,0,0,0-.307-2.4l-.678-6.859a4.709,4.709,0,0,0-.563-1.8,4.653,4.653,0,0,0-1.219-1.426l-6.873-5.386a4.389,4.389,0,0,1,1.35-1.208,3.035,3.035,0,0,0,1.114-.714c.479-.652.072-1.623.4-2.365.246-.554.849-.864,1.2-1.361.722-1.017.2-2.422-.34-3.549l-3.133-6.542a29.629,29.629,0,0,0-2.958-5.233c-3.716-4.889-10.867-7.321-16.7-5.2a6.628,6.628,0,0,0-3.9,3.4,8.951,8.951,0,0,1-.753,1.693c-.8,1.125-2.358,1.337-3.473,2.146a5.167,5.167,0,0,0-1.753,4.76A15.364,15.364,0,0,0,98.08,50a15.529,15.529,0,0,0,3.049,4.633c.636.589,1.415,1.136,1.618,1.983a15.492,15.492,0,0,1-.069,2.23,2.28,2.28,0,0,0,.266.894c-3.076.389-5.259,2.971-6.237,6.811-.06.238-.084.369-.084.369L96.19,70.9c-.009.172,0,.338,0,.5a5.276,5.276,0,0,0,.548,2.585V87.946L83.577,96.362c-1.974.886-1.535,7.974,2.413,9.3s7.46-7.073,7.46-7.073c2.4-.163,6.447-3.4,8.621-5.908a3.994,3.994,0,0,0,1.146,1.206c-1.568,3.571-4.67,10.958-4.175,12.457.3.9,8,.988,16.327.81a4,4,0,0,0,.668.3,2.988,2.988,0,0,0,2.559-.378C127.6,106.814,136.311,106.345,136.311,106.345ZM125.2,79.269c.182-.511.782-.79,1.584-.923v5.386Zm-.766-18.925.025-.039Z",
    transform: "translate(11.388 4.456)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.5,67.825s-.417,14.935-.833,16.829-6.453,7.563-9.581,7.782c0,0-3.332,7.993-7.081,6.732s-4.166-7.993-2.29-8.835l12.5-7.995V66.352Z",
    transform: "translate(11.553 9.167)",
    fill: "#fdb797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.276,83.724S96.861,95.5,97.486,97.4s35.4,0,35.4,0-6.457-6.521-5.206-13.674Z",
    transform: "translate(13.461 11.567)",
    fill: "#3ad29f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.446,53.2s.834,8.2-.625,10.1,5.831,2.954,6.457,2.954a67.544,67.544,0,0,0,8.538-2.954c1.247-.641,2.29-5.258,2.29-5.258s-6.248,1.263-8.122-6.093Z",
    transform: "translate(14.455 7.176)",
    fill: "#fdb797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.572,34.644a6.293,6.293,0,0,0-3.7,3.226,8.583,8.583,0,0,1-.715,1.608c-.759,1.067-2.239,1.268-3.29,2.031A4.911,4.911,0,0,0,95.2,46.03a14.481,14.481,0,0,0,1.7,4.728,14.713,14.713,0,0,0,2.9,4.4c.6.554,1.343,1.078,1.536,1.883a14.571,14.571,0,0,1-.066,2.12c.15,1.748,2.219,2.563,3.947,2.757a2.533,2.533,0,0,0,2.14-.456,3.741,3.741,0,0,0,.578-1.012,4.83,4.83,0,0,1,1.749-1.958,4.763,4.763,0,0,1,5.027-.052,4.837,4.837,0,0,1,1.789,1.921c.405.787.641,1.743,1.378,2.216,1.128.739,2.637-.127,3.473-1.195s1.435-2.4,2.621-3.041a2.953,2.953,0,0,0,1.061-.679c.455-.618.067-1.542.378-2.245.234-.53.807-.82,1.14-1.292.686-.966.183-2.3-.323-3.37l-2.975-6.213a28.346,28.346,0,0,0-2.808-4.97C116.9,34.941,110.107,32.631,104.572,34.644Z",
    transform: "translate(13.147 4.685)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.178,64.129s8.122,0,10.206-7.57l6.837,5.354a4.457,4.457,0,0,1,1.681,3.07l.645,6.514s.732,2.419-.1,3.892c0,0-8.643-2.216-8.851.316l6.032,17.038s-9.372.21-11.871-1.477c0,0-10.2,2.1-12.7-.21s-5-2.1-2.924-7.363a10.489,10.489,0,0,1-2.291-10.1c1.875-5.89.1.105.1.105s-4.045-2-3.837-5.794l.417-3.787s.022-.126.08-.351c1.27-4.985,4.681-7.755,9.478-5.99a4.349,4.349,0,0,0,2.835-.076S106.347,64.55,112.178,64.129Z",
    transform: "translate(13.138 7.814)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.178,63.759s8.122,0,10.206-7.57l6.837,5.354a4.457,4.457,0,0,1,1.681,3.071l.645,6.514s.732,2.419-.1,3.892c0,0-8.643-2.216-8.851.316l6.032,17.038s-9.372.211-11.871-1.477c0,0-10.2,2.1-12.7-.21s-5-2.1-2.924-7.363a10.489,10.489,0,0,1-2.291-10.1c1.875-5.89.1.105.1.105s-4.045-2-3.837-5.785l.417-3.787s.022-.126.08-.351c1.27-4.985,4.681-7.755,9.478-5.989a4.349,4.349,0,0,0,2.835-.076S106.347,64.18,112.178,63.759Z",
    transform: "translate(13.138 7.763)",
    fill: "#252a62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.565,69.3s-.417,14.935-.833,16.829-6.457,7.57-9.58,7.782c0,0-3.333,7.993-7.082,6.732s-4.166-7.993-2.291-8.835l12.5-7.993V67.827Z",
    transform: "translate(15.016 9.371)",
    fill: "#fdb797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.17,69.956s4.789,3.283,8.957,3.01c0,0,.417-5.639-.834-5.954S120.62,67.011,119.17,69.956Z",
    transform: "translate(16.464 9.244)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.17,69.771s4.789,3.283,8.957,3.01c0,0,.417-5.639-.834-5.954S120.62,66.826,119.17,69.771Z",
    transform: "translate(16.464 9.219)",
    fill: "#252a62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.251,52.305l-8.538,1.263s.192,1.9.23,4.079A9.512,9.512,0,0,0,116,56,9.5,9.5,0,0,1,114.251,52.305Z",
    transform: "translate(14.605 7.226)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.989,59.646a9.677,9.677,0,1,0-9.581-9.677A9.629,9.629,0,0,0,109.989,59.646Z",
    transform: "translate(13.872 5.567)",
    fill: "#fdb797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.408,48.5a2.969,2.969,0,0,1-1.28.185q-2.54-.017-5.08-.185a6.189,6.189,0,0,1-3.64-1.069,4.225,4.225,0,0,1-.854-4.81,8.55,8.55,0,0,1,3.57-3.693,10.6,10.6,0,0,1,2.691-1.226,8.965,8.965,0,0,1,7.965,2.018,14.241,14.241,0,0,1,4.308,7.289c.254.96.582,2.1,1.523,2.4a2.551,2.551,0,0,1-3.254.692c-1.62-.777-2.449-3.754-3.9-4.223C112.834,45.356,113.777,47.867,112.408,48.5Z",
    transform: "translate(13.977 5.173)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.408,48.317a2.971,2.971,0,0,1-1.28.185q-2.54-.017-5.08-.185a6.19,6.19,0,0,1-3.64-1.069,4.226,4.226,0,0,1-.854-4.81,8.55,8.55,0,0,1,3.57-3.693,10.6,10.6,0,0,1,2.689-1.222,8.962,8.962,0,0,1,7.964,2.018,14.25,14.25,0,0,1,4.309,7.289c.254.96.58,2.1,1.523,2.4a2.552,2.552,0,0,1-3.254.692c-1.62-.777-2.449-3.754-3.9-4.223C112.834,45.171,113.777,47.678,112.408,48.317Z",
    transform: "translate(13.977 5.148)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.316,80.09a36.562,36.562,0,0,1,9.578-1.263Z",
    transform: "translate(13.859 10.89)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.465,69.956s-3.124,2.314-2.291,3.576Z",
    transform: "translate(16.169 9.665)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.82 102.549)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.424,90.1H48.166v9.032h5.952v28.412h90.566V99.134h5.74Z",
    transform: "translate(-48.166 -90.101)",
    fill: "#fff",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M142.924,94.723H54.205v32.186h88.719Z",
    transform: "translate(7.489 13.087)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.924,96.2H54.205v5.048h88.719Z",
    transform: "translate(7.489 13.291)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.256,91.581H49.082v8.624H149.256Z",
    transform: "translate(6.781 12.652)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.668,89.715H62.884a1.194,1.194,0,0,0-1.188,1.2v.334a1.194,1.194,0,0,0,1.188,1.2H79.668a1.194,1.194,0,0,0,1.188-1.2v-.334A1.194,1.194,0,0,0,79.668,89.715Z",
    transform: "translate(8.524 12.395)",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(81.881 71.621)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.4,62.928H77.1a5.185,5.185,0,0,0-5.158,5.21V90.975a5.185,5.185,0,0,0,5.158,5.21h37.3a5.184,5.184,0,0,0,5.158-5.21V68.138A5.184,5.184,0,0,0,114.4,62.928Z",
    transform: "translate(-71.941 -62.928)",
    fill: "#fff",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M112.893,63.466h-35.3a4.931,4.931,0,0,0-4.906,4.956V91.154a4.931,4.931,0,0,0,4.906,4.956h35.3a4.93,4.93,0,0,0,4.905-4.956V68.422A4.93,4.93,0,0,0,112.893,63.466Z",
    transform: "translate(10.042 8.768)",
    fill: "#3e3f49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.442,63.466h-35.3a4.931,4.931,0,0,0-4.906,4.956V91.154a4.931,4.931,0,0,0,4.906,4.956h35.3a4.931,4.931,0,0,0,4.905-4.956V68.422A4.931,4.931,0,0,0,113.442,63.466Z",
    transform: "translate(10.118 8.768)",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.084,79.262a1.473,1.473,0,1,0-1.459-1.473A1.466,1.466,0,0,0,95.084,79.262Z",
    transform: "translate(12.935 10.543)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.494,95.276s1.232,1.826,4.886,2.385Z",
    transform: "translate(5.871 13.163)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.725,13.874H59.746V6.489H72.725Zm-12.43-.554H72.176V7.043H60.294Z",
    transform: "translate(8.254 0.896)",
    fill: "#0d71e8",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.127,13.874H71.148V6.489H84.127ZM71.7,13.32H83.578V7.043H71.7Z",
    transform: "translate(9.83 0.896)",
    fill: "#0d71e8",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.529,13.874H82.551V6.489H95.529ZM83.1,13.32H94.981V7.043H83.1Z",
    transform: "translate(11.405 0.896)",
    fill: "#0d71e8",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.933,13.874H93.955V6.489h12.978ZM94.5,13.32h11.881V7.043H94.5Z",
    transform: "translate(12.98 0.896)",
    fill: "#0d71e8",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.529,7.385H82.551V0H95.529ZM83.1,6.831H94.981V.554H83.1Z",
    transform: "translate(11.405)",
    fill: "#0d71e8",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.127,7.385H71.148V0H84.127ZM71.7,6.831H83.578V.554H71.7Z",
    transform: "translate(9.83)",
    fill: "#0d71e8",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.484,13.874H17.506V6.489H30.484Zm-12.43-.554H29.936V7.043H18.054Z",
    transform: "translate(2.419 0.896)",
    fill: "#0d71e8",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.887,13.874H28.908V6.489H41.887Zm-12.43-.554H41.338V7.043H29.457Z",
    transform: "translate(3.994 0.896)",
    fill: "#0d71e8",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.887,7.385H28.908V0H41.887Zm-12.43-.554H41.338V.554H29.457Z",
    transform: "translate(3.994)",
    fill: "#0d71e8",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.06,13.874H117.082V6.489H130.06Zm-12.43-.554h11.881V7.043H117.631Z",
    transform: "translate(16.176 0.896)",
    fill: "#0d71e8",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.462,13.874H128.484V6.489h12.978Zm-12.43-.554h11.882V7.043H129.033Z",
    transform: "translate(17.751 0.896)",
    fill: "#0d71e8",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.462,7.385H128.484V0h12.978Zm-12.43-.554h11.882V.554H129.033Z",
    transform: "translate(17.751)",
    fill: "#0d71e8",
    opacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/hero.f38c7b7c1cddf0635fc2216647befe47.svg";
export { ForwardRef as ReactComponent };